import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {gpCommon} from "../GasPass";
import {Query} from "../libs/Query";

let controllerInfoFormMap = null;
let controllerInfoFormMapMarker = null;

const ControllerInfoForm = ({ data, requireUrl, inBlock, yandexMapApi }) => {

    const [mapCoordinates, setMapCoordinates] = useState( null );

    useEffect( () => {

        return () => {
            controllerInfoFormMapMarker = null;
            controllerInfoFormMap = null;
        }

    }, [] );

    useEffect(() => {
        if( mapCoordinates !== null ) {
            let mapLatitude = gpCommon.getFloat( mapCoordinates['latitude'], null );
            let mapLongitude = gpCommon.getFloat( mapCoordinates['longitude'], null );
            if( ( mapLatitude !== null ) && ( mapLongitude !== null ) ) {
                let mapElement = gpCommon.getElement( 'map' );
                if( mapElement !== null ) {

                    try {
                        if( controllerInfoFormMap === null ) {
                            controllerInfoFormMap = new yandexMapApi.Map( 'map', {
                                center: [mapLatitude, mapLongitude],
                                zoom: 15,
                                controls: []
                            }, {
                                suppressMapOpenBlock: true,
                                suppressObsoleteBrowserNotifier: true,
                                yandexMapDisablePoiInteractivity: true
                            });
                            controllerInfoFormMap.behaviors.disable([ 'drag', 'scrollZoom', 'multiTouch', 'leftMouseButtonMagnifier', 'rightMouseButtonMagnifier', 'dblClickZoom' ]);
                        }

                        if( controllerInfoFormMapMarker === null ) {
                            controllerInfoFormMapMarker = new yandexMapApi.Placemark(
                                [ mapLatitude, mapLongitude ]
                            );

                            controllerInfoFormMap.geoObjects.add( controllerInfoFormMapMarker );

                        }
                        else {
                            controllerInfoFormMapMarker.geometry.setCoordinates([ mapLatitude, mapLongitude ]);
                            controllerInfoFormMap.setCenter( [ mapLatitude, mapLongitude ], 15, { duration: 350 } );
                        }

                    }
                    catch( e ) {
                        //
                    }

                }
            }
        }
    }, [mapCoordinates, yandexMapApi] );


    return(
        <table className="infoForm">
            {( inBlock && ( gpCommon.getString( data['title'], null ) !== null ) ) && <thead>
                <tr>
                    <th colSpan="2">{gpCommon.getString( data['title'], '' )}</th>
                </tr>
            </thead>}
            {( ( gpCommon.getArray( data['form'], null ) !== null ) || ( gpCommon.getArray( data['button'], null ) !== null ) ) ? ( <tbody>
                {gpCommon.getArray( data['form'], [] ).map( ( item ) => {
                    if( gpCommon.getString( item['id'], '' ) === 'map' ) {
                        let cellCoordinates = gpCommon.getObject( item['coordinates'], null );
                        if( cellCoordinates !== null ) {

                            let newMapCoordinates = { latitude: gpCommon.getFloat( cellCoordinates['latitude'], null ), longitude: gpCommon.getFloat( cellCoordinates['longitude'], null ) }
                            if( !gpCommon.isMatchObjects( newMapCoordinates, mapCoordinates ) ) {
                                setMapCoordinates( newMapCoordinates );
                            }

                            return (
                                <tr key={gpCommon.getString( item['id'], '' )}>
                                    <td colSpan="2">
                                        <div id="map"></div>
                                    </td>
                                </tr>
                            );
                        }
                    }

                    if( gpCommon.getString( item['type'], '' ) === 'separator' ) {
                        return (
                            <tr key={gpCommon.getString( item['id'], '' )}>
                                <td colSpan="2"><div className="separator"></div></td>
                            </tr>
                        );
                    }

                    if( gpCommon.getString( item['type'], '' ) === 'header' ) {
                        return (
                            <tr key={gpCommon.getString( item['id'], '' )}>
                                <td colSpan="2"><center className="secondary">{gpCommon.getString( item['header'], '' )}</center></td>
                            </tr>
                        );
                    }

                    return (
                        <tr key={gpCommon.getString( item['id'], '' )} className={( gpCommon.getString( item['url'], null ) !== null ) ? "selectable" : undefined} onClick={( e ) => onClickButton( item )}>
                            <td>{gpCommon.getString( item['title'], '' )}
                                {gpCommon.getString( item['subtitle'], null ) !== null && <br />}
                                {gpCommon.getString( item['subtitle'], null ) !== null && <span>{gpCommon.getString( item['subtitle'], '' )}</span>}
                            </td>
                            <td>
                                {gpCommon.getString( item['value'], '' )}
                                {gpCommon.getString( item['description'], null ) !== null && <br />}
                                {gpCommon.getString( item['description'], null ) !== null && <span>{gpCommon.getString( item['description'], '' )}</span>}
                            </td>
                        </tr>
                    );
                })}

                {gpCommon.getArray( data['button2'], null ) !== null && <tr>
                    <td colSpan="2">
                        <div className="bottomButtons">
                            {gpCommon.getArray( data['button2'], []).map( ( button ) => {
                                return (
                                    <input key={gpCommon.getString( button['id'], '' )} type="button"
                                           value={gpCommon.getString( button['value'], '' )}
                                           onClick={(e) => onClickButton( button )} />
                                );
                            })}
                        </div>
                    </td>
                </tr>}

                {gpCommon.getArray( data['button'], null ) !== null && <tr>
                    <td colSpan="2">
                        <div className="bottomButtons">
                            {gpCommon.getArray(data['button'], []).map((button) => {
                                return (
                                    <input key={gpCommon.getString(button['id'], '')} type="button"
                                           value={gpCommon.getString(button['value'], '')}
                                           onClick={(e) => onClickButton(button)}/>
                                );
                            })}
                        </div>
                    </td>
                </tr>}
            </tbody> ) : ( <tbody>
                <tr>
                    <td className="empty" colSpan="2">{gpCommon.getString( data['form']['description'], 'Данные не найдены' )}</td>
                </tr>
            </tbody> )}
        </table>
    );

    function onClickButton( button ) {
        if( gpCommon.getString( button['url'], null ) ) {
            let buttonAction = gpCommon.getString( button['action'], null );
            if( buttonAction === 'link' ) {
                // Open link
                window.open( new Query().LINK_URL + button['url'], '_blank' );

            }
            else {
                requireUrl( button['url'], {}, null );
            }
        }
    }

}
ControllerInfoForm.propTypes = {
    data: PropTypes.object.isRequired,
    requireUrl: PropTypes.func.isRequired,
    inBlock: PropTypes.bool.isRequired,
    yandexMapApi: PropTypes.any
};
export default ControllerInfoForm;
